import { CalendarDays, List } from "lucide-react";

export function ViewToggle({ view, setView }) {
  return (
    <div className="inline-flex rounded-full border border-slate-200 bg-white p-1" data-testid="sessions-view-toggle">
      {[["calendar", "Week", CalendarDays], ["list", "List", List]].map(([v, l, I]) => (
        <button key={v} onClick={() => setView(v)} data-testid={`view-toggle-${v}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors ${view === v ? "bg-[#0B1A33] text-white" : "text-slate-500 hover:text-[#0B1A33]"}`}>
          <I className="h-4 w-4" />{l}
        </button>
      ))}
    </div>
  );
}
